import React from "react";
import Skeleton from "react-loading-skeleton";

const SiteWiseInspectionStatsV2 = ({ data, loading = true }) => {
  const skeletonRows = Array.from({ length: 4 });

  return (
    <section className="dashboard-v2__table-section">
      <h2 className="dashboard-v2__table-title">
        Site Wise <span>Inspection Report</span>
      </h2>
      <div className="dashboard-v2__table-wrap">
        <div className="table-responsive">
          <table className="table dashboard-v2__table mb-0">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Site</th>
                <th>Job Designation</th>
                <th>Inspection Assignee</th>
                <th>Inspections Score</th>
                <th>Inspection Count</th>
                <th>Finding Count</th>
              </tr>
            </thead>
            <tbody>
              {loading
                ? skeletonRows.map((_, index) => (
                    <tr key={index}>
                      <td><Skeleton width={20} /></td>
                      <td><Skeleton width={100} /></td>
                      <td><Skeleton width={100} /></td>
                      <td><Skeleton width={100} /></td>
                      <td><Skeleton width={40} /></td>
                      <td><Skeleton width={40} /></td>
                      <td><Skeleton width={40} /></td>
                    </tr>
                  ))
                : data?.map((user, index) => (
                    <tr key={`${user.uuid}-${user.siteId}`}>
                      <td>{index + 1}</td>
                      <td>{user?.siteName}</td>
                      <td>{user?.designation}</td>
                      <td>{user?.name}</td>
                      <td>{user?.inspectionScore?.toFixed(2)}</td>
                      <td>{user?.inspectionCount}</td>
                      <td>{user?.findingCount}</td>
                    </tr>
                  ))}
            </tbody>
          </table>
        </div>
        {data?.length === 0 && !loading && (
          <p className="dashboard-v2__empty-table">No Data Found</p>
        )}
      </div>
    </section>
  );
};

export default SiteWiseInspectionStatsV2;
